export const Langs = [
  'en', 'es',
]

export const LangsToISO = (lang) => ({
  'es': 'es-US',
  'en': 'en-US',
}[lang])

export const defaultLang = 'en'
